import { MenuFilter } from "@/common/MenuFilter";
import { TypeCell } from "@/common/TypeCell";
import { DEFAULT_NOTE_TYPES, DEFAULT_NOTE_TYPES_LABELS, NOTE_STATUS } from "@/services/api";
import type { NotesTableColumnGetter, NotesTableColumnsProps } from "../types";
import type { NotesTableRowData } from "../types/notes-table-types";
import { NOTES_TABLE_COLUMNS_KEYS } from "../notes-table-columns-keys";
import { getRowTextColor } from "../../lib/get-row-text-color";

export type NotesTableNoteTypeColumnProps = NotesTableColumnsProps<{
  colorize?: boolean;
  menuFilters?: MenuFilter[];
  onChangeMenuFilters?: (selected: string[]) => void;
}>;

export type NotesTableNoteTypeColumnGetter = NotesTableColumnGetter<NotesTableNoteTypeColumnProps>;

export const getNotesTableNoteTypeColumn: NotesTableNoteTypeColumnGetter = ({
  title = "Type",
  dataIndex = ["noteType.name"],
  width = 160,
  key = NOTES_TABLE_COLUMNS_KEYS.type,
  sorter = (a: NotesTableRowData, b: NotesTableRowData) =>
    a?.noteType.name?.localeCompare(b?.noteType.name),
  showSorterTooltip = false,

  menuFilters = [],
  onChangeMenuFilters = () => "",
  filterDropdown = () => <MenuFilter onChange={onChangeMenuFilters} filters={menuFilters} />,
  colorize,
  render = (_, record) => (
    <TypeCell
      type={DEFAULT_NOTE_TYPES_LABELS[record.noteType.name]}
      textColor={getRowTextColor(
        record,
        colorize && DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT === record.noteType.name,
      )}
      disabled={
        record.status === NOTE_STATUS.DONE &&
        record.noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT
      }
    />
  ),
  onFilter = (value, record) => record?.noteType.name?.includes(value as string),
  ...props
}) => {
  return {
    title: title,
    dataIndex: dataIndex,
    width: width,
    key: key,
    sorter: sorter,
    filterDropdown: filterDropdown,
    onFilter: onFilter,
    render: render,
    showSorterTooltip: showSorterTooltip,
    ...props,
  };
};
